<template>
    <div>
        <div v-if="rows && rows.length > 0">
                <table class="table">
                    <component :is="headerTemplateSelection" :header="header" :actions="actions" :selected="selectedAll" v-on:selectAll="selectAllMethod"></component>
                    <component :is="bodyTemplateSelection" :header="header" :body="body" :rows="rows" :actions="actions" :selected="selectedAll"></component>
                    <template v-if="footerTitles && footerRow">
                        <component :is="headerTemplateSelection" :header="footerTitles" :actions="actions" :selected="selectedAll" @selectAll="selectedAll = $event"></component>
                        <component :is="bodyTemplateSelection" :header="header" :body="body" :rows="footerRow" :actions="actions" :selected="selectedAll"></component>
                    </template>
                </table>
        </div>
        <div v-else-if="showNoDataMessage" class="text-center empty-panel align-content-center fs-super dark bold">No data available</div>
    </div>
</template>

<script>
export default {
    data: function() {
        return {
            selectedAll: false
        }
    },
    props: {
        header: Object,
        body: Object,
        rows: Array,
        footerTitles: Object,
        footerRow: Array,
        showNoDataMessage:{
            default: true
        },
        actions: {
            type: Object,
            default: function() {
                return {};
            }
        }
    },
    computed: {
        headerTemplateSelection() {
            return this.triggerPath(this.header, './baseHeader');
        },
        bodyTemplateSelection() {
            return this.triggerPath(this.body, './baseBody');
        }
    },
    methods: {
        triggerPath(prop, baseTemplate) {
            var path = (prop && prop.template !== undefined && prop.template) ? prop.template : baseTemplate;

            if (path === '') {
                return;
            }

            try {
                return require(`${path}`);
            }
            catch (e) {
                console.log('Unable to find (' + path + ') for this automated list');
            }
        },
        selectAllMethod: function(status){
            this.header.selection.event(status);
        }
    }
}
</script>

<style scoped>
    .table-responsive {
        display: block;
        width: 100%;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
    }
</style>



// WEBPACK FOOTER //
// baseList.vue?55b972fd